$(() => {
    // Verifica hash ao iniciar
    URI.init();

    //PopUP's
    if ($('.popup-modal').length > 0) {
        let delay = 0;

        function getPopupImageSignature($modal: JQuery<HTMLElement>) {
            const imageSrc = $modal.find('img').first().attr('src');
            return imageSrc || $modal.attr('id') || '';
        }

        function getPopupCookieName(signature: string) {
            let hash = 0;

            for (let i = 0; i < signature.length; i++) {
                hash = ((hash << 5) - hash) + signature.charCodeAt(i);
                hash = hash & hash;
            }

            return `popup_shown_${Math.abs(hash)}`;
        }

        $('.popup-modal').each(function (index) {
            const $modal = $(this);
            const popupSignature = getPopupImageSignature($modal);
            const cookieName = getPopupCookieName(popupSignature);
            const cookies = <any>$;

            $modal.on('hidden.bs.modal', () => {
                cookies.cookie(cookieName, popupSignature, { expires: 3650, path: '/' });
            });

            if (cookies.cookie(cookieName) !== popupSignature) {
                setTimeout(() => {
                    (<any>$modal).modal('show');
                }, delay);
                delay += 2000; // Delay each popup by 2 seconds
            }
        });
    }

    // // Menu
    // $(".m-m-submenu a").click(function() {
    //     $(this).parent('.m-m-submenu').hide();
    // });

    // $(".m-menu").hover(function(){
    //     $(this).find('.m-m-submenu').slideDown();
    // }, function() {
    //     $(this).find('.m-m-submenu').hide();
    // });

    //Acessibilidade
    const fontLevelKey = 'p5_accessibility_font_level';
    const contrastKey = 'p5_accessibility_high_contrast';
    const fontStep = 2;
    const minFontLevel = -2;
    const maxFontLevel = 5;
    const fontClasses = 'p5-font-scale--2 p5-font-scale--1 p5-font-scale-0 p5-font-scale-1 p5-font-scale-2 p5-font-scale-3 p5-font-scale-4 p5-font-scale-5';
    const ignoreFontElements = 'script, style, link, meta, title, noscript, svg, path, img, picture, source, video, audio, canvas, iframe, br';
    const iconSelector = '.mdi, [class^="mdi-"], [class*=" mdi-"], .fa, [class^="fa-"], [class*=" fa-"]';

    function getFontLevel() {
        let level = parseInt(localStorage.getItem(fontLevelKey) || '0', 10);
        return isNaN(level) ? 0 : level;
    }

    function setFontLevel(level: number) {
        level = Math.max(minFontLevel, Math.min(maxFontLevel, level));
        localStorage.setItem(fontLevelKey, String(level));
        applyFontLevel();
    }

    function hasScalableText($el: JQuery<HTMLElement>) {
        if ($el.is('input, textarea, select, button')) {
            return true;
        }

        let hasText = false;
        $el.contents().each(function () {
            if (this.nodeType === 3 && $.trim(this.nodeValue || '').length) {
                hasText = true;
                return false;
            }
        });

        return hasText;
    }

    function applyFontLevel() {
        const level = getFontLevel();
        const $body = $('body');
        const fontElements: { element: JQuery<HTMLElement>, fontSize: number }[] = [];

        $body.removeClass(fontClasses).addClass('p5-font-scale-' + level);

        $('body').find('*').not(ignoreFontElements).not(iconSelector).each(function () {
            const $el = $(this);
            if ($el.closest(iconSelector).length) {
                return;
            }

            if (!hasScalableText($el)) {
                return;
            }

            const originalFontSize = parseFloat($el.attr('data-p5-original-font-size') || $el.css('font-size'));
            if (isNaN(originalFontSize)) {
                return;
            }

            if (!$el.attr('data-p5-original-font-size')) {
                $el.attr('data-p5-original-font-size', String(originalFontSize));
            }

            fontElements.push({
                element: $el,
                fontSize: originalFontSize,
            });
        });

        fontElements.forEach((item) => {
            if (level === 0) {
                item.element.css('font-size', '');
                item.element.removeAttr('data-p5-original-font-size');
            } else {
                item.element.css('font-size', (item.fontSize + (level * fontStep)) + 'px');
            }
        });
    }

    function applyContrast() {
        const enabled = localStorage.getItem(contrastKey) === '1';
        $('body, html').toggleClass('p5-high-contrast', enabled);
        $('.p5-accessibility-body, .p5-accessibility-content')
            .toggleClass('p5-bgcolor-black', enabled)
            .toggleClass('p5-bgcolor-white', !enabled);
    }

    $('#font-plus-button').click(function () {
        setFontLevel(getFontLevel() + 1);
    });

    $('#font-less-button').click(function () {
        setFontLevel(getFontLevel() - 1);
    });

    $('#background-contrast-button').click(() => {
        const enabled = localStorage.getItem(contrastKey) === '1';
        localStorage.setItem(contrastKey, enabled ? '0' : '1');
        applyContrast();
    });

    applyFontLevel();
    applyContrast();
    $(document).ajaxComplete(() => {
        applyFontLevel();
        applyContrast();
    });
    $(window).on('hashchange', () => {
        setTimeout(() => {
            applyFontLevel();
            applyContrast();
        }, 300);
    });

    // Menu fixed scroll
    var windowWidth = $(window).width();

    if (windowWidth > 767) {
        $(window).scroll(() => {
            let menuTop = $('.header').outerHeight();
            let menuHeight = $('#menu-desktop').outerHeight();
            let scrollTop = $(window).scrollTop();
            if (scrollTop > menuTop) {
                $('#menu-desktop').addClass('fixed-top navbar-scrolled');
                $('body').css('margin-top', menuHeight);
                $('#footer-btn-back-top').fadeIn('slow');
            } else {
                $('#menu-desktop').removeClass('fixed-top navbar-scrolled');
                $('body').css('margin-top', 0);
                $('#footer-btn-back-top').fadeOut('slow');
            }
        });
    }

    $(document).off('click', '.menu-mobile');
    $(document).on('click', '.menu-mobile', function (e) {
        e.stopPropagation();
        $('.menu-mobile-container').addClass('open');
    });

    $(document).off('click', '.menu-mobile-container-click');
    $(document).on('click', '.menu-mobile-container-click', function (e) {
        e.stopPropagation();
        $('.menu-mobile-container').removeClass('open');
        (<any>$('.collapse')).collapse('hide');
    });

    $(document).on('click', function (e) {
        if ($(e.target).closest('.menu-mobile-container').length === 0) {
            $('.menu-mobile-container').removeClass('open');
            (<any>$('.collapse')).collapse('hide');
        }
    });

    /*Search*/
    $('#search-btn').click(function () {
        let search: any = $('#search').val();
        if (search.length > 2) {
            window.location.href = '/#/search/' + encodeURIComponent(search);
        }
    });

    $('#search').keyup(function (event: any) {
        if (event.keyCode == 13) {
            $('#search-btn').click();
        }
    });

    // $("#search-btn-m").click(function(){
    //     let search: any = $("#search-m").val();
    //     if (search.length > 2) {
    //         window.location.href = '/#/search/'+encodeURIComponent(search);
    //     }
    // });

    // $("#search-m").keyup(function (event: any) {
    //     if(event.keyCode == 13){
    //         $("#search-btn-m").click();
    //     }
    // });

    // $("#search-m").click(function (event: any) {
    //     event.stopPropagation();
    // });

    $('#footer-btn-back-top').click(function () {
        $('body, html').animate({ scrollTop: 0 }, 900);
    });
});
